export const DEFAULT_CASE_SLUG = "hsr-lunchdrop";
export const CASE_ORDER = ["quickcart-pulse", "hsr-lunchdrop", "clauseguard-ai", "brewdesk-london"];
export const CASE_LABELS = {
  "quickcart-pulse": { label: "QuickCart Pulse India", short: "QuickCart Pulse" },
  "hsr-lunchdrop": { label: "HSR LunchDrop", short: "HSR LunchDrop" },
  "clauseguard-ai": { label: "ClauseGuard AI US", short: "ClauseGuard AI" },
  "brewdesk-london": { label: "BrewDesk London", short: "BrewDesk London" },
};

export const VERDICT_STYLES = {
  PURSUE: { ring: "#10B981", pill: "bg-emerald-500/15 text-emerald-300 border-emerald-400/40" },
  PURSUE_WITH_CHANGES: { ring: "#06B6D4", pill: "bg-cyan-500/15 text-cyan-300 border-cyan-400/40" },
  PIVOT: { ring: "#F59E0B", pill: "bg-amber-500/15 text-amber-300 border-amber-400/40" },
  DO_NOT_PURSUE_AS_DESCRIBED: { ring: "#F43F5E", pill: "bg-rose-500/15 text-rose-300 border-rose-400/40" },
};

export const ARCHETYPE_LABELS = {
  saas_ai_aggregator: "SaaS / AI / Price Aggregator",
  food_cloud_kitchen: "Restaurant / Cloud Kitchen / Office Food",
  enterprise_b2b_saas: "Enterprise B2B SaaS",
  physical_retail_cafe_coworking: "Physical Retail / Cafe / Co-Working",
  coaching_consulting_agency: "Coaching / Consulting / Agency",
  manufacturing_hardware: "Manufacturing / Hardware",
  two_sided_marketplace: "Two-Sided Marketplace",
  regulated_health_fintech: "Regulated HealthTech / FinTech",
};

export const STAGES = [
  { n: 1, code: "01", title: "Overview & Vs. Rivals", tier: "Start" },
  { n: 2, code: "02", title: "Idea & Country Intake", tier: "Free" },
  { n: 3, code: "03", title: "360° Scorecard (20 Criteria)", tier: "Free" },
  { n: 4, code: "04", title: "3D Concept & Test Website", tier: "Free Preview" },
  { n: 5, code: "05", title: "16-Ch Growth & Elite Concierge", tier: "Growth/Elite" },
];

export const COMPARISON_ROWS = [
  {
    key: "parameters", label: "Number of Tested Parameters",
    validatorai: "6 vague paragraphs", generic: "Generic template sections, unweighted",
    iv360: "All 20 Explicit Criteria — 12 Universal + 8 Industry Overlay, weighted & deterministic",
  },
  {
    key: "unit-economics", label: "Unit Economics & Cost Math",
    validatorai: "Zero numbers", generic: "Broad market-size guesses, no unit math",
    iv360: "Exact ₹160 meal COGS & ₹7 batched drop math (INR + USD)",
  },
  {
    key: "visual-layout", label: "Visual Layout",
    validatorai: "Plain text wall", generic: "Long-form text report",
    iv360: "100% Uniform 4-Tile Bento Grid across 7 teardown sections",
  },
  {
    key: "legal", label: "Local Legal Specifics",
    validatorai: "None", generic: "Generic compliance mentions",
    iv360: "Exact FoSCoS/DPDP portals & fees",
  },
  {
    key: "preview", label: "Live Website Preview",
    validatorai: "External Base44 ad redirect", generic: "No native test site",
    iv360: "Native Subdomain Test Site + Agency vs AI Cost Anchor",
  },
];

export const FAQS = [
  {
    q: "How does IdeaValidator360 score a startup idea?",
    a: "Every idea is stress-tested on 20 explicit criteria: 12 universal criteria plus 8 industry-specific overlay criteria. Each criterion gets a 0–10 score with sourced evidence; the weights are normalised to 100 and the final score is computed deterministically, so you can verify the maths line by line.",
  },
  {
    q: "What are the Local, Country and Global lenses?",
    a: "The same idea is read through three geographies: your local pin-code or neighbourhood, your country, and the global market. Each lens shows demand signals, competition and regulation with a cited source and date.",
  },
  {
    q: "Is the validation really free?",
    a: "Yes. The Free Explorer tier includes 1 Free Assessment: the 20-criteria scorecard, 3 geographic lenses, the 7-section bento teardown, customer discovery scripts, a 3D visual concept and a test preview website. A downloadable PDF report and a done-for-you live website are optional one-time unlocks.",
  },
  {
    q: "What is the 30-minute test website preview?",
    a: "For each validated idea IdeaValidator360 drafts a mobile-responsive test website with brand name, tagline, hero copy and features, so you can start collecting real sign-ups within about 30 minutes instead of commissioning an agency.",
  },
  {
    q: "How is IdeaValidator360 different from ValidatorAI and generic AI idea tools?",
    a: "Instead of a few paragraphs of generic text, you get all 20 criteria scored with citations, exact unit economics in INR and USD, local legal specifics, a uniform 4-tile bento teardown and a native test website — with fatal-flaw detection and a recommended safe pivot when an idea should not be pursued as described.",
  },
  {
    q: "What do the Growth and Elite tiers include?",
    a: "Growth adds a 10-question founder intake and a 16-chapter investor-grade dossier with top-down and bottom-up TAM-SAM-SOM, M.A.N. buyer qualification, a 24-month 3-scenario financial model, 5 validation experiments and 30/60/90-day plus 12-month roadmaps. Elite adds human advisory, CA/CS/legal company registration concierge and an investor readiness audit.",
  },
];
